import { render, staticRenderFns } from "./TripStatisticBar.vue?vue&type=template&id=66fb6861&scoped=true&"
import script from "./TripStatisticBar.vue?vue&type=script&lang=ts&"
export * from "./TripStatisticBar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66fb6861",
  null
  
)

export default component.exports